import { render, staticRenderFns } from "./DispatchedSingleRecipientEmailCommunication.vue?vue&type=template&id=40128f01&scoped=true"
import script from "./DispatchedSingleRecipientEmailCommunication.vue?vue&type=script&lang=ts"
export * from "./DispatchedSingleRecipientEmailCommunication.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40128f01",
  null
  
)

export default component.exports